<template>
  <GameIntro
    :title="__('games.show.bingo.title')"
    :game="game"
    :games-url="gamesUrl"
    :member-can-play-game="memberCanPlayGame"
    :cannot-play-error-message="__('games.games.bingo.cannot_play')"
  />

  <section class="container grid grid-cols-1 gap-4 mb-6 md:mb-12">
    <div class="bg-white shadow rounded w-full p-4">
      <h2 class="font-bold mb-4">
        {{ __('games.show.bingo-winners.title') }}
      </h2>

      <div class="flex flex-wrap mt-4 mb-2 text-xs md:text-sm">
        <span class="w-3/12 font-bold">
          {{ __('games.show.winners.date') }}
        </span>
        <span class="w-4/12 font-bold pl-3">
          {{ __('games.show.bingo-winners.amount') }}
        </span>
        <span class="w-5/12 font-bold pl-3">
          {{ __('games.show.winners.name') }}
        </span>
      </div>

      <div class="divide-solid divide-y divide-gray-300 mb-3 md:mb-6 md:border-t md:border-gray-300">
        <template v-if="winners && winners.data && winners.data.length > 0">
          <div
            v-for="(highscore, i) in winners.data"
            :key="`highscore-${i}`"
            class="flex flex-wrap py-2"
          >
            <span class="w-3/12 text-xs leading-5 md:text-base">
              {{ highscore.date }}
            </span>
            <span class="w-4/12 text-xs leading-5 md:text-base pl-3">
              {{ highscore.prize }}
            </span>
            <span class="w-5/12 text-xs leading-5 md:text-base pl-3 truncate">
              {{ highscore.username }}
            </span>
          </div>
        </template>

        <div
          v-else
          class="flex flex-wrap py-2"
        >
          <span class="w-full text-center text-xs leading-5 md:text-base">
            {{ __('games.show.bingo-winners.no-results') }}
          </span>
        </div>
      </div>

      <div
        v-if="winners.meta && winners.meta.pagination && winners.meta.pagination.links.length > 3"
      >
        <Pagination
          :pagination="winners.meta.pagination"
          :on-each-side="3"
        />
      </div>
    </div>
  </section>
</template>

<script>
import GameIntro from './Components/Intro.vue';
import Pagination from '../../../Components/Pagination.vue';

export default {
  components: {
    GameIntro,
    Pagination,
  },

  props: {
    game: {
      type: Object,
      required: true,
    },

    gamesUrl: {
      type: String,
      required: true,
    },

    winners: {
      type: Object,
      required: true,
    },

    memberCanPlayGame: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
